
  <header role="banner" class="navbar navbar-dark bg-dark navbar-expand-md supra">
    <nav class="container-fluid">
      <ul class="navbar-nav ml-auto">
          <li class="nav-item" ngbDropdown *ngIf="userObject">
            <button class="btn btn-link nav-link" id="dropdownLanguage" ngbDropdownToggle>
              {{userObject.name}}&nbsp;
              <fa-icon icon="user"></fa-icon>
            </button>
            <ul ngbDropdownMenu aria-labelledby="dropdownLanguage">
              <li *ngIf="changeTenants">
                <a ngbDropdownItem routerLink="/tenants">Change tenant</a>
              </li>
              <li>
                <a ngbDropdownItem (click)="logout()">Logout</a>
              </li>
            </ul>
          </li>
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownLanguage" ngbDropdownToggle>{{selectRegion.name}}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownLanguage">
              <li *ngFor="let region of regions">
                <a ngbDropdownItem
                  [class.active]= "region.current"
                  attr.aria-label={{region.name}}
                  attr.aria-current={{region.current}}
                  hreflang={{region.name}}
                  (click)="changeRegion(region)">{{region.name}}</a>
              </li>
            </ul>
          </li>
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownLanguage" ngbDropdownToggle>{{selectLanguage.name}}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownLanguage">
              <li *ngFor="let language of languages">
                <a ngbDropdownItem
                  [class.active]= "language.current"
                  attr.aria-label={{language.label}}
                  attr.aria-current={{language.current}} lang={{language.lang}}
                  hreflang={{language.lang}}
                  (click)="changeLanguage(language)">{{language.name}}</a>
              </li>
            </ul>
          </li>
      </ul>
    </nav>
  </header>

  <header role="banner" class="navbar navbar-dark bg-dark navbar-expand-lg">
    
  </header>


  <div class="row">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-12">
      <div class="">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
  </div>

  <div class="row">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">
      <app-error></app-error>
    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
  </div>

  <div class="row">
    <div class="col-xl-12 p-0">
      <div>
        <app-banner></app-banner>
      </div>
    </div>
  </div>

  <div class="row p-0">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
      <div class="pt-2 pb-2">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <a (click)="scrollUp()" class="o-scroll-up" title="back to top">
    <span class="d-none d-sm-inline-block">{{ 'buttons.backtotop' | translate }}</span>
  </a>

  <div class="o-footer" role="contentinfo">
    <h2 class="sr-only">Site map & informations</h2>
    <div class="o-footer-top">
        <div class="container">
            <div class="row mb-0 pb-1">
              If you identify a bug, or have issues with this portal please email us at &nbsp;<a href="mailto:portalsupport@orangecyberdefense.com"> portalsupport@orangecyberdefense.com</a>
            </div>
            <div class="row mb-0">
                <ul class="nav align-items-center">
                  <li class="nav-item"><span class="nav-link">Follow us:</span></li>
                  <li class="nav-item"><a class="nav-link btn btn-social btn-twitter" target="_social" href="https://twitter.com/orangecyberdef" rel="noopener noreferrer"><span class="sr-only">Twitter</span></a></li>
                  <li class="nav-item"><a class="nav-link btn btn-social btn-linkedin" target="_social" href="https://www.linkedin.com/company/orange-cyberdefense/" rel="noopener noreferrer"><span class="sr-only">Linkedin</span></a></li>
                </ul>
            </div>
            <div class="row mb-0">
                If you identify a vulnerability with this portal please email us at &nbsp;<a href="mailto:infosec@orangecyberdefense.com"> infosec@orangecyberdefense.com</a>
            </div>
        </div>
    </div>
  </div>
